import { MenuItem, Select, FormHelperText } from "@mui/material";
import { Component } from "react";
import { styled } from '@mui/material/styles';

const CustomSelect = styled(Select)(({ theme }) => ({
    "& .MuiOutlinedInput-notchedOutline legend": { 
        display: "none", 
    }
}));

class CustomizedSelect extends Component {
    render() {
        return (this.props.label ? 
            <div className="without-side-padding">
                <Select
                    {...this.props}
                    fullWidth
                    MenuProps={{
                        anchorOrigin: { vertical: "bottom", horizontal: "center" },
                        transformOrigin: { vertical: "top", horizontal: "center" },
                        className: this.props.menuclasses
                    }}
                >
                    {this.props.children ?? this.props.options.map((o) => (
                        <MenuItem key={o.value} value={o.value}>
                            {o.label}
                        </MenuItem>
                    ))}
                </Select>
                {this.props.helperText ? 
                   <FormHelperText>{this.props.helperText}</FormHelperText>                     
                : null}
            </div>
            
            :
            <div>
                <CustomSelect
                    {...this.props}
                    fullWidth
                    MenuProps={{
                        anchorOrigin: { vertical: "bottom", horizontal: "center" },
                        transformOrigin: { vertical: "top", horizontal: "center" },
                        className: this.props.menuclasses
                    }}
                >
                    {this.props.children ?? this.props.options.map((o) => (
                        <MenuItem key={o.value} value={o.value}>
                            {o.label}
                        </MenuItem>
                    ))}
                </CustomSelect>   
                {this.props.helperText ? 
                   <FormHelperText>{this.props.helperText}</FormHelperText>                     
                : null}
            </div>                     
        );
    }
}

export default CustomizedSelect;
